/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */

/**
 * Product metadata shared by the About modal and the generated documentation
 * PDF, so the two can never drift apart.
 */

export const DEXTER_TITLE = "Dexter";

export const DEXTER_DOCUMENT_TITLE = "User Documentation";

export const DEXTER_DESCRIPTION =
  "Dexter is a powerful data transformation platform that helps you convert " +
  "between different data formats like Protobuf, XML, and more. Organize your " +
  "data into collections and transform it with a visual interface to build " +
  "custom outputs.";

/**
 * SBIR data rights legend printed on the PDF cover page.
 */
export const DATA_RIGHTS_LEGEND =
  "Tactical software delivered by SimVentions, Inc. will have government " +
  "Purpose Rights. The government may use, modify, reproduce, release, " +
  "perform, display, or disclose this data. Government has a royalty-free " +
  "license to use, and to authorize others to use on its behalf, data for " +
  "government purposes. Tactical software is any software that is used " +
  "operationally or as a test tool in the evaluation of a tactical " +
  "warfighting system. Non-tactical software delivered by SimVentions, Inc. " +
  "under this delivery order is subject to SBIR Data Rights as described in " +
  "Defense Federal Acquisition Regulations System (DFARS) 252.227-7018. In " +
  "accordance with these rights, the government has a royalty-free license " +
  "to use, and authorize others to use in its behalf, data for government " +
  "purposes.";
